import { useProcedure } from '@hook'
import { DeleteModal } from '@ui'
import { getError, showToast } from '@util'
import { useState } from 'react'

type Props = {
  onClose: () => void
  id?: string
}

const RemoveProcedure = ({ id, onClose }: Props) => {
  const { deleteProcedure } = useProcedure()
  const [isLoading, setIsLoading] = useState(false)
  const handleDelete = async () => {
    setIsLoading(true)
    try {
      await deleteProcedure({ id: id || '' })
      showToast('Procedure deleted successfully')
      onClose()
    } catch (err: any) {
      getError(err)
    }
    setIsLoading(false)
  }
  return (
    <DeleteModal
      description="Confirm that you want to delete this procedure"
      handleSubmit={handleDelete}
      isLoading={isLoading}
      onClose={onClose}
      title="Delete Procedure"
    />
  )
}

export default RemoveProcedure
